import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import srOnly from '@helpers/srOnly';
import styled from 'styled-components';
const Container = styled.button `
  ${transition('background-size, background-color, border-color, color', 0.2)}

  display: inline-flex;
  align-items: center;
  border: var(--borderWidth) solid var(--colourBorder);
  background: var(--colourBg);
  background-image: linear-gradient(to right, var(--colourBgHover), var(--colourBgHover));
  background-repeat: no-repeat;
  background-size: 0% 100%;
  color: var(--colourText);
  height: ${fluid(44, 46)};
  padding: 0 ${fluid(12, 16)};
  text-decoration: none;
  user-select: none;
  width: auto;

  /* Mobile click styles - button should mimic press */
  @media ${until(Device.TabletLarge)} {
    ${transition('transform', 0.15)};

    &:active {
      transform: translateY(1.5px);
    }
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-width: 2px;
    outline-style: solid;
  }

  &[data-active='false']:hover {
    color: var(--colourTextActive);
    border-color: var(--colourBorderActive);
    text-decoration-color: currentColor;
    background-size: 100% 100%;
  }

  &[data-icon-only='true'] {
    height: ${fluid(44, 60)};
    justify-content: center;
    padding: 0;
    width: ${fluid(44, 60)};
  }

  &[data-active='true'] {
    background-color: var(--colourBgActive);
    color: var(--colourText);
    border-color: var(--colourBorder);
    background-size: 0% 100;
  }

  /* Increase specificity to override :not(span) style */
  &:disabled {
    opacity: 0.66;
    background-size: 0% 100%;
    pointer-events: none;
  }

  [data-site='mep'] & {
    border-radius: 6px;
  }

  /* Colour settings */
  --borderWidth: 1px;
  --colourBorder: ${brand.global.red};
  --colourBorderActive: ${brand.global.red};
  --colourBg: ${brand.global.white};
  --colourBgHover: ${brand.global.red};
  --colourText: ${brand.global.red};
  --colourTextActive: ${brand.global.white};

  [data-site='ess'] & {
    --colourBgActive: ${brand.ess.secondary.lightestGrey};
  }

  [data-site='mep'] & {
    --colourBgActive: ${brand.mep.secondary.lightestGrey};
  }
`;
const Text = styled.span `
  ${transition('color', 0.2)}
  ${fonts.daxWide.bold};

  color: currentColor;
  font-size: ${fluid(16, 18)};
  line-height: 1em;
  text-decoration: none;
  text-transform: uppercase;

  [data-icon-only='true'] & {
    ${srOnly};
  }
`;
const IconWrapper = styled.div `
  ${transition('color', 0.2)}

  display: block;
  color: currentColor;
  height: 14px;
  margin: 0;
  padding: 0;

  > svg {
    height: 14px;
  }

  [data-icon-position='left'] & {
    margin-right: auto;
    order: -1;
    padding-right: 12px;
  }

  [data-icon-position='right'] & {
    margin-left: auto;
    order: 1;
    padding-left: 12px;
  }

  [data-icon-only='true'] & {
    color: currentColor;
    height: 22px;
    margin: 0;
    padding: 0;

    > svg {
      height: 22px;
    }
  }
`;
const TabButtonStyles = {
    Container,
    IconWrapper,
    Text,
};
export default TabButtonStyles;
